import React from 'react'

interface ErrorProps {
  id: string
  label: string
  isError: boolean
}

const ErrorLabel = ({ id, label, isError }: ErrorProps): JSX.Element => (
  isError
    ? <div className="flex justify-center items-center text-sm text-red-500"> { label }</div>
    : <></>
)

export default ErrorLabel
